import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { requestAccess } from 'project/ducks/ndas';
import { getProject } from 'project/ducks/project';
import { canRequestProjectAccess } from 'project/utils';
import NDAd from 'project/components/brief/ndad';

const mapStateToProps = (state, { params }) => {
  return {
    user: state.user.profile_data,
    contract: state.project.ndas.ndaContract,
    project: getProject(state),
    canRequestAccess: canRequestProjectAccess(state)
  }
}

export default withRouter(connect(mapStateToProps, {
  requestAccess,
})(NDAd));



// WEBPACK FOOTER //
// ./project/containers/brief_ndad.js